import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    product: {},
    category: {},
  },
  getters,
  actions,
  mutations,
};
